import { useCallback, useMemo } from 'react';
import { useAuthStore } from '@/store/authStore';

export function useTenantScope() {
  const user = useAuthStore((state) => state.user);
  const selectedTenantId = useAuthStore((state) => state.selectedTenantId);
  const setSelectedTenantState = useAuthStore((state) => state.setSelectedTenant);

  const isSuperAdmin = !user?.tenant_id;
  const tenantId = useMemo(
    () => (isSuperAdmin ? selectedTenantId || undefined : user?.tenant_id),
    [isSuperAdmin, selectedTenantId, user?.tenant_id]
  );

  const setSelectedTenant = useCallback(
    (tenantId: string | null | undefined) => {
      setSelectedTenantState(tenantId || null);
    },
    [setSelectedTenantState]
  );

  return {
    tenantId,
    isSuperAdmin,
    selectedTenantId,
    setSelectedTenant,
    requireTenantSelection: isSuperAdmin && !tenantId,
  };
}
